/*
  Tap-to-preview color swatches, scoped only to cards that opt in via
  data-swatch-preview-only (set by product-grid.liquid when a caller
  passes cardConsistentLayout: true - currently only the "Current
  Favorites" featured-collection instance; see
  sections/featured-collection.liquid and templates/index.json).

  assets/theme.js's own colorMediaInit() already attaches a bubble-phase
  click listener directly on every [data-card-color-option] swatch that
  navigates to that color's product URL - that behavior is exactly right
  everywhere else (Collection Tabs, the main collection grid, the cart's
  "You may also like", search, etc.) and is left completely untouched.

  This file adds a SEPARATE, capture-phase listener on document. Capture
  always runs before an element's own bubble-phase listener, so calling
  stopPropagation() here - only for swatches inside a
  [data-swatch-preview-only] card - keeps theme.js's per-swatch click
  listener from ever running for those swatches, without editing theme.js
  itself. Every other swatch on the site never matches the ancestor check
  below and falls straight through, completely unaffected.
*/
(function () {
  function previewSwatchColor(swatch) {
    var productGrid = swatch.closest("[data-product-grid]");
    if (!productGrid) return;
    var mainImageGrid = productGrid.querySelector("[data-main-image]");
    var allImageElement = swatch.querySelector("script");
    var currentActive = productGrid.querySelector(".product-swatch-item.active");
    if (currentActive) currentActive.classList.remove("active");
    swatch.classList.add("active");
    if (allImageElement && mainImageGrid) {
      try {
        var swatchMedia = new DOMParser()
          .parseFromString(JSON.parse(allImageElement.textContent), "text/html")
          .querySelector(".media-content");
        if (swatchMedia) mainImageGrid.innerHTML = swatchMedia.innerHTML;
      } catch (e) {}
    }
    // Re-point the card's own navigation links (image + title) at the
    // previewed color's PDP, using the same data-product-url each swatch
    // already carries (previously used only to navigate away on click).
    // Without this, tapping the image/title right after a preview would
    // still open the color that was showing on page load.
    var targetUrl = swatch.getAttribute("data-product-url");
    if (targetUrl) {
      if (mainImageGrid && mainImageGrid.tagName === "A") {
        mainImageGrid.setAttribute("href", targetUrl);
      }
      var titleLink = productGrid.querySelector(".product-name");
      if (titleLink) {
        var titleAnchor = titleLink.tagName === "A" ? titleLink : titleLink.closest("a");
        if (titleAnchor) titleAnchor.setAttribute("href", targetUrl);
      }
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      var swatch = event.target.closest("[data-card-color-option]");
      if (!swatch) return;
      if (!swatch.closest("[data-swatch-preview-only]")) return;
      event.stopPropagation();
      event.preventDefault();
      previewSwatchColor(swatch);
    },
    true,
  );
})();
